export const pluralDimensionToSingle = {
    categories: 'category',
    brands: 'brand',
    hashtags: 'hashtag',
};

export const tikTokHealthStatKeys = [
    'average weekly views',
    'paid views',
    'sentiment score',
    'posts',
    'engagement',
    'TikTok shop',
];

export const formatAddedOn = (addedOn) => {
    try {
        return addedOn.split('-').map(Number).join('-');
    } catch (_err) {
        return null;
    }
};

/** Header row of key indexes, then one array of values per record. */
export const shapeTimeSeries = (timeSeries) => {
    if (!(timeSeries && timeSeries.length)) return null;
    if (timeSeries.every(({ real_volume }) => real_volume === null))
        return null;
    const keys = Array.from(new Set(timeSeries.map(Object.keys).flat()));
    return [
        keys.reduce((acc, k, idx) => {
            acc[k] = idx;
            return acc;
        }, {}),
    ].concat(timeSeries.map((record) => keys.map((k) => record[k])));
};
